import {
  AnnulusFluidBase,
  AnnulusInjector,
  AnnulusSpace,
} from 'src/app/interfaces/annulus-space';

export const ANNULUS_SPACES: AnnulusSpace[] = [
  {
    handoverId: 165,
    wellId: '5400004724',
    numAnular: 2,
    tipoAnular: 'CASING a CASING',
    diamTubInt: 5.5,
    tipoTubInt: 'CASING',
    diamTubExt: 9.625,
    tipoTubExt: 'CASING',
    num: 1,
    presionCasing: 0,
    fechaFin: new Date('2021-04-11 09:33:01.0'),
    hasMeasuredPressure: true,
    pressureMeasureDate: new Date('2021-04-11 09:33:01.0'),
    measuredPressure: 5.45,
    annulusFluidBaseId: 1,
    averageDensity: 32.123,
    comments: 'Lorem ipsum test',
  },
];

export const ANNULUS_FLUID_BASES: AnnulusFluidBase[] = [
  {
    annulusFluidBaseName: 'Water',
    annulusFluidBaseId: 1,
  },
  {
    annulusFluidBaseName: 'Oil',
    annulusFluidBaseId: 2,
  },
  {
    annulusFluidBaseName: 'Bryne',
    annulusFluidBaseId: 3,
  },
  {
    annulusFluidBaseName: 'Synthetic',
    annulusFluidBaseId: 4,
  },
  {
    annulusFluidBaseName: 'Other',
    annulusFluidBaseId: 5,
  },
];

export const ANNULUS_INJECTOR: AnnulusInjector = {
  pressures: [
    {
      handoverId: 165,
      annularTypeId: 2,
      fluidDensity: 8.4,
      maxSurfacePressure: 0,
    },
  ],
  casingLoss: {
    handoverId: 165,
    injectionPressure: 0,
    maxThicknessLossPercentage: 0,
  },
};
